import React, { useEffect, useRef, useState } from "react";

import { useHistory, useLocation } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import Select from "react-select";

import {
  Button,
  Flex,
  Input,
  InputGroup,
  Grid,
  GridItem,
  SimpleGrid,
  Divider,
} from "@chakra-ui/react";

import ServicoAcolhimentoService from "../../../main/services/ServicoAcolhimentoService";
import DadosGeograficosService from "../../../main/services/DadosGeograficosService";
import PromotoriaService from "../../../main/services/PromotoriaService";
import VaraService from "../../../main/services/VaraService";
import TipoServicoAcolhimentoService from "../../../main/services/TipoServicoAcolhimentoService";
import {
  Permission,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";

export default function FiltersSA(props) {
  const formRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const { entidade, setData } = props;
  const roleKeycloack = props.roleKeycloack;

  const [initialValues, setInitialValues] = useState({
    nomeFantasia: "",
    promotoriaId: "",
    varaInfanciaId: "",
    estadoId: "",
    municipioId: "",
    bairroId: "",
    status: "",
    naturezaServico: "",
    regime: "",
    modalidade: "",
    razaoSocial: "",
  });
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const [promotorias, setPromotorias] = useState({
    options: [],
    isLoading: false,
  });
  const [varas, setVaras] = useState({ options: [], isLoading: false });
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [modalidades, setModalidades] = useState({
    options: [],
    isLoading: false,
  });
  const [regime, setRegime] = useState();
  const [regimes, setRegimes] = useState({ options: [], isLoading: false });
  const [municipio, setMunicipio] = useState();
  const initialLoad = useRef(true);

  const customSelectStyle = {
    control: (provided, state) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
    }),
  };

  const normalizeText = (text) =>
    text
      ?.toString()
      ?.normalize("NFD")
      ?.replace(/[̀-ͯ]/g, "")
      ?.replace(/[^a-zA-Z0-9\s]/g, "")
      ?.toLowerCase();

  const normalizedFilterOption = (option, inputValue) => {
    const input = normalizeText(inputValue || "");
    const label = normalizeText(option?.data?.nome || option?.label || "");
    return label?.includes(input);
  };

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-filter")) {
      const tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      setInitialValues(tempObj);
      setRegime(tempObj.regime);
      setMunicipio(tempObj.municipioId);
    }
    DadosGeograficosService.getEstados().then((res) => {
      setEstados(res.data);
    });
  }, [entidade]);

  useEffect(() => {
    let tempTestEmpty = true;
    for (let key in initialValues) {
      if (initialValues[key] && key !== "estadoId") {
        tempTestEmpty = false;
      }
    }
    if (!tempTestEmpty) {
      if (formRef.current) {
        formRef.current.handleSubmit();
      }
    }
  }, [initialValues, regime, municipio]);

  useEffect(() => {
    if (regime) {
      setModalidades((prevState) => ({ ...prevState, isLoading: true }));
      TipoServicoAcolhimentoService.pesquisarModalidades(regime.value).then(
        (res) => {
          const tempData = res.data.map((modalidade) => {
            return { label: modalidade, value: modalidade };
          });
          setModalidades({ options: tempData, isLoading: false });
        }
      );
    } else {
      setModalidades({ options: [], isLoading: false });
    }
  }, [regime]);

  useEffect(() => {
    if (municipio) {
      setBairros((prevState) => ({ ...prevState, isLoading: true }));
      DadosGeograficosService.pesquisarBairros(municipio.id).then((res) => {
        setBairros({ options: res.data, isLoading: false });
      });
    } else {
      setBairros({ options: [], isLoading: false });
    }
  }, [municipio]);

  useEffect(() => {
    if (estados.length !== 0) {
      const tempEst = estados.find(
        (estado) => estado.nome.toUpperCase() === "Rio de Janeiro".toUpperCase()
      );
      if (tempEst !== undefined) {
        setInitialValues((prevState) => ({
          ...prevState,
          estadoId: tempEst.id,
        }));
      }
    }
  }, [estados]);

  useEffect(() => {
    if (!initialLoad.current) {
      if (formRef.current) {
        formRef.current.handleSubmit();
      }
    } else {
      initialLoad.current = false;
    }
  }, [location]);

  const handleGetMunicipios = () => {
    setMunicipios({ ...municipios, isLoading: true });
    DadosGeograficosService.getMunicipios().then((res) => {
      const estadosDoRJ = res.data.filter((estado) => estado.uf.id === 33);
      setMunicipios({ options: estadosDoRJ, isLoading: false });
    });
  };

  const handleGetPromotorias = (props) => {
    setPromotorias({ ...promotorias, isLoading: true });
    PromotoriaService.pesquisarPromotorias({
      municipioId: props.values?.municipioId?.id
        ? props.values?.municipioId?.id
        : "",
    }).then((res) => {
      setPromotorias({ options: res.data, isLoading: false });
    });
  };

  const handleGetVaras = () => {
    setVaras({ ...varas, isLoading: true });
    VaraService.getVaras().then((res) => {
      setVaras({ options: res.data, isLoading: false });
    });
  };

  const handleGetRegimes = () => {
    setRegimes({ ...regimes, isLoading: true });
    TipoServicoAcolhimentoService.pesquisarTipoServicoAcolhimento(
      "",
      "ativos",
      ""
    ).then((res) => {
      const tempRegimes = res.data.map((tsa) => tsa.regime);
      let tempRegimesFinal = [];
      if (tempRegimes.find((regime) => regime === "SAI")) {
        tempRegimesFinal = ["SAI"];
      }
      if (tempRegimes.find((regime) => regime === "SAF")) {
        tempRegimesFinal = [...tempRegimesFinal, "SAF"];
      }
      if (tempRegimesFinal.length === 2) {
        tempRegimesFinal = ["SAF", "SAI"];
      }
      const tempData = tempRegimesFinal.map((regime) => {
        if (regime === "SAI") {
          return {
            label: "Serviço de Acolhimento Institucional",
            value: regime,
          };
        } else {
          return { label: "Serviço de Acolhimento Familiar", value: regime };
        }
      });
      setRegimes({ options: tempData, isLoading: false });
    });
  };

  const handleSubmit = (values, actions) => {
    setTimeout(async () => {
      const valuesToSend = {
        ...values,
        regime: values.regime ? values.regime.value : "",
        promotoriaId: values.promotoriaId ? values.promotoriaId.id : "",
        varaInfanciaId: values.varaInfanciaId ? values.varaInfanciaId.id : "",
        estadoId: values.estadoId ? values.estadoId.id : "",
        municipioId: values.municipioId ? values.municipioId.id : "",
        bairroId: values.bairroId ? values.bairroId.id : "",
        modalidade: values.modalidade ? values.modalidade.value : "",
      };
      sessionStorage.setItem(entidade + "-filter", JSON.stringify(values));

      props.setLoading(true);
      await ServicoAcolhimentoService.pesquisarServicosAcolhimento(
        valuesToSend
      ).then((res) => {
        const filteredData = res.data.filter((item) => !!item.nomeFantasia);
        setData(filteredData);
      });
      props.setLoading(false);
      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <Flex flexDir="column" alignItems="center" w="100%">
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
        innerRef={formRef}
      >
        {(props) => (
          <Form style={{ width: "100%" }}>
            <Flex flexDirection="column" alignItems="center">
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                  xl: "repeat(4, 1fr)",
                }}
                gap="17px"
                w="100%"
                mt="2px"
              >
                <GridItem colSpan={{ base: 1, sm: 2 }} h="35px">
                  <Field name="nomeFantasia">
                    {({ field, form }) => (
                      <InputGroup>
                        <Input
                          {...field}
                          name="nomeFantasia"
                          autoFocus
                          id="search-nomeFantasia"
                          backgroundColor="white"
                          autoComplete="off"
                          placeholder="Pesquise pelo Nome do Serviço de Acolhimento"
                        />
                      </InputGroup>
                    )}
                  </Field>
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    isClearable={true}
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Sem opções"}
                    styles={customSelectStyle}
                    value={props.values.promotoriaId || ""}
                    searchable={true}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    getOptionLabel={(option) => option.nome}
                    getOptionValue={(option) => option.id}
                    autoload={false}
                    isLoading={promotorias.isLoading}
                    options={promotorias.options}
                    placeholder="Selecione a Promotoria"
                    filterOption={normalizedFilterOption}
                    onChange={(value) => {
                      props.setFieldValue("promotoriaId", value);
                    }}
                    onFocus={() => handleGetPromotorias(props)}
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Sem opções"}
                    isClearable={true}
                    styles={customSelectStyle}
                    value={props.values.varaInfanciaId || ""}
                    searchable={true}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    getOptionLabel={(option) => option.nome}
                    getOptionValue={(option) => option.id}
                    autoload={false}
                    isLoading={varas.isLoading}
                    options={varas.options}
                    placeholder="Selecione a Vara da Infância"
                    filterOption={normalizedFilterOption}
                    onChange={(value) => {
                      props.setFieldValue("varaInfanciaId", value);
                    }}
                    onFocus={varas.options.length === 0 ? handleGetVaras : null}
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Field name="estadoId">
                    {({ field, form }) => (
                      <>
                        <Input
                          name="estadoId"
                          id="search-estadoId"
                          isDisabled
                          value="Rio de Janeiro"
                          autoComplete="off"
                        />
                        <Input
                          {...field}
                          type="hidden"
                          name="estadoId"
                          id="estadoId"
                        />
                      </>
                    )}
                  </Field>
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Sem opções"}
                    isClearable={true}
                    styles={customSelectStyle}
                    value={props.values.municipioId || ""}
                    searchable={true}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    getOptionLabel={(option) => option.nome}
                    getOptionValue={(option) => option.id}
                    autoload={false}
                    isLoading={municipios.isLoading}
                    options={municipios.options}
                    placeholder="Selecione a Cidade"
                    onChange={(value) => {
                      props.setFieldValue("municipioId", value);
                      setMunicipio(value);
                      props.setFieldValue("promocaoId", "");
                      props.setFieldValue("bairroId", null);
                    }}
                    onFocus={
                      municipios.options.length === 0
                        ? handleGetMunicipios
                        : null
                    }
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Sem opções"}
                    isClearable={true}
                    styles={customSelectStyle}
                    value={props.values.bairroId || ""}
                    searchable={true}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    getOptionLabel={(option) => option.nome}
                    getOptionValue={(option) => option.id}
                    autoload={false}
                    isLoading={bairros.isLoading}
                    options={bairros.options}
                    placeholder="Selecione o Bairro"
                    onChange={(value) => {
                      props.setFieldValue("bairroId", value);
                    }}
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    isClearable={true}
                    styles={customSelectStyle}
                    value={
                      [
                        { label: "Ativos", value: "ativos" },
                        { label: "Desativados", value: "desativados" },
                        { label: "Suspensos", value: "suspensos" },
                      ].find(
                        (option) => props.values.status === option.value
                      ) || ""
                    }
                    searchable={true}
                    options={[
                      { label: "Ativos", value: "ativos" },
                      { label: "Desativados", value: "desativados" },
                      { label: "Suspensos", value: "suspensos" },
                    ]}
                    placeholder="Filtrar por Status"
                    onChange={(value) => {
                      props.setFieldValue("status", value ? value.value : "");
                    }}
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    isClearable={true}
                    styles={customSelectStyle}
                    value={
                      [
                        { label: "Privada", value: "privada" },
                        { label: "Pública", value: "publica" },
                      ].find(
                        (option) =>
                          props.values.naturezaServico === option.value
                      ) || ""
                    }
                    searchable={true}
                    options={[
                      { label: "Privada", value: "privada" },
                      { label: "Pública", value: "publica" },
                    ]}
                    placeholder="Selecione a Natureza"
                    onChange={(value) => {
                      props.setFieldValue(
                        "naturezaServico",
                        value ? value.value : ""
                      );
                    }}
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    isClearable={true}
                    styles={customSelectStyle}
                    value={props.values.regime || ""}
                    searchable={true}
                    options={regimes.options}
                    placeholder="Selecione o Regime"
                    onChange={(value) => {
                      props.setFieldValue("regime", value);
                      setRegime(value);
                    }}
                    onFocus={
                      regimes.options.length === 0 ? handleGetRegimes : null
                    }
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Select
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Sem opções"}
                    isClearable={true}
                    styles={customSelectStyle}
                    value={props.values.modalidade || ""}
                    searchable={true}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    autoload={false}
                    isLoading={modalidades.isLoading}
                    options={modalidades.options}
                    placeholder="Selecione a Modalidade"
                    onChange={(value) => {
                      props.setFieldValue("modalidade", value);
                    }}
                  />
                </GridItem>

                <GridItem colSpan={1} h="35px">
                  <Field name="razaoSocial">
                    {({ field, form }) => (
                      <Input
                        {...field}
                        name="razaoSocial"
                        id="search-razaoSocial"
                        backgroundColor="white"
                        autoComplete="off"
                        placeholder="Pesquise pela Razão Social"
                      />
                    )}
                  </Field>
                </GridItem>
              </Grid>

              <SimpleGrid
                mt="20px"
                columns={{ base: 3, lg: 3 }}
                spacing="15px"
                w={{ base: "100%", lg: "47%" }}
              >
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={servicoAcolhimentoFunc.pesquisar}
                >
                  <Button
                    id="button-pesquisar-serv"
                    type="submit"
                    translate="no"
                    color="#FFF"
                    backgroundColor="#169499"
                    fontWeight={700}
                    fontSize="15px"
                    lineHeight="21.6px"
                    _hover={{ bg: "#169499" }}
                    isLoading={props.isSubmitting}
                  >
                    Pesquisar
                  </Button>
                </Permission>
                <Button
                  id="button-limpar-serv"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  onClick={() => {
                    let tempEstId;
                    if (estados.length !== 0) {
                      const tempEst = estados.find(
                        (estado) =>
                          estado.nome.toUpperCase() ===
                          "Rio de Janeiro".toUpperCase()
                      );
                      if (tempEst !== undefined) {
                        tempEstId = tempEst.id;
                      }
                    }
                    sessionStorage.removeItem(entidade + "-filter");
                    props.resetForm({
                      values: {
                        nomeFantasia: "",
                        promotoriaId: "",
                        varaInfanciaId: "",
                        estadoId: tempEstId || "",
                        municipioId: "",
                        bairroId: "",
                        status: "",
                        naturezaServico: "",
                        regime: "",
                        modalidade: "",
                        razaoSocial: "",
                      },
                    });
                  }}
                >
                  Limpar
                </Button>
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={servicoAcolhimentoFunc.cadastrar}
                >
                  <Button
                    id="button-cadastrar-serv"
                    color="#FFF"
                    backgroundColor="#169499"
                    fontWeight={700}
                    fontSize="15px"
                    lineHeight="21.6px"
                    _hover={{ bg: "#169499" }}
                    onClick={() => {
                      history.push("/" + entidade + "/cadastrar");
                    }}
                  >
                    Cadastrar
                  </Button>
                </Permission>
              </SimpleGrid>
            </Flex>
          </Form>
        )}
      </Formik>

      <Divider
        borderColor="#DDEBEA"
        orientation="horizontal"
        mt="18px"
        h="2px"
      />
    </Flex>
  );
}
